<tec-list-layout>
    <tec-title-group [title]="'COMPANIES.TITLE' | translate" [description]="'COMPANIES.DESCRIPTION' | translate">
        @if (rolePermissions.canCreateCompany()) {
            <tec-button [label]="'BUTTON.CREATE' | translate" (clickEvent)="goToCreate()" />
        }
    </tec-title-group>

    <ng-container content>
        <!-- ERROR  -->
        @if(alertError) {
        <tec-alert status="error" [msg]="alertError" (closeAlert)="alertError = ''" />
        }

        <tec-item-filter>
            <tec-toolbar
                [toolbar]="toolbar()"
                [maxFilter]="3"
                (formFilter)="filterChange($event)"
                (actionClick)="onToolbarAction($event)"
            />

            <tec-item-group>
                @if (listLoading) {
                    @for (skeleton of listSkeletonItems; track skeleton) {
                        <tec-item [loading]="true" />
                    }
                } @else if (companiesList && companiesList.length > 0) {
                    @for (company of companiesList; track company.uuid) {
                        <tec-item
                            [tagImage]="{ icon: 'icon-briefcase', status: 'default' }"
                            [title]="company.name"
                            [detailAction]="company.created_at"
                        >
                            <tec-tag [status]="company.enabled ? 'success' : 'disabled'">
                                {{ (company.enabled ? 'COMPANIES.ACTIVE' : 'COMPANIES.INACTIVE') | translate }}
                            </tec-tag>

                            @if (company.code) {
                                <tec-info-group>
                                    <b>{{ 'COMPANIES.LIST.CODE_LABEL' | translate }}</b>
                                    <span>{{ company.code | uppercase }}</span>
                                </tec-info-group>
                            }

                            <tec-link (click)="goToDetail(company, $event)">{{ 'GENERAL.SHOW_DETAILS' | translate }}</tec-link>

                            @if (getItemMenuOpt(company).length > 0) {
                                <tec-menu [options]="getItemMenuOpt(company)" (valueChange)="itemMenuChange($event, company)">
                                    <tec-button-icon [icon]="'icon-more'" [type]="'default'" />
                                </tec-menu>
                            }
                        </tec-item>
                    }

                    <tec-pagination
                        class="pagination-no-margin"
                        [pagination]="config.pagination"
                        [elementsByPage]="config.pagination.elementsByPage"
                        [label]="config.pagination.label"
                        (paginationChange)="paginationChange($event)"
                    />
                } @else if (companiesList?.length === 0) {
                    <tec-empty-state
                        [title]="'COMPANIES.NO_RESULTS' | translate"
                        [description]="'COMPANIES.NO_RESULTS_DESCRIPTION' | translate"
                        type="notresults"
                    />
                }
            </tec-item-group>
        </tec-item-filter>

        <tec-watermark type="default" />
    </ng-container>
</tec-list-layout>

@if(showDetail) {
<app-companies-detail
    [id]="companySelected?.uuid"
    [company]="companySelected"
    (closeEvent)="closeDetail()"
    (editEvent)="editFromDetail()"
    (menuChange)="onDetailMenuChange($event)"
/>
}
@if(showForm) {
<app-companies-form [id]="companySelected?.uuid" (closeEvent)="closeForm($event)" />
}
@if (showModalCurl) {
<app-modal-curl-request
    [titleKey]="curlModalTitleKey"
    [curlText]="selectedCompanyCurl"
    [tagImage]="curlTagImage"
    (closeEvent)="closeModalCurl()"
/>
}
